import {Route, Routes} from "react-router-dom";
import List from "./List";
import Detail from "./Detail";
import Post from "./Post";
import {RouterProps} from "../../RouterProps";
import Edit from "./Edit";
import HistoryRouter from "./history/HistoryRouter";

export default function LevelRouter(props: RouterProps) {
    return <>
        <Routes>
            <Route path={'/'} element={<List {...props} />} />
            <Route path={'/post'} element={<Post {...props} />} />
            <Route path={'/:userLevelId'} element={<Detail {...props} />} />
            <Route path={'/:userLevelId/edit'} element={<Edit {...props} />} />
            <Route path={'/histories/*'} element={<HistoryRouter {...props} />} />
        </Routes>
    </>
}